(function () {
  class ShippingEstimator {
    constructor() {
      this.cache = window.__boxes24ShippingCache || (window.__boxes24ShippingCache = {});
      this.additionalTransitDays = 3;
      this.displayMultiplier = 1.55;
      this.saDisplayMultiplier = 1.2;
      this.drawerStorageKey = "boxes24DrawerShippingPostcode";
      this.freeShippingMinimum = 300;

      this.SA_PRODUCT_IDS = new Set([
        "8104343797839",
        "8104380694607",
        "8118058844239",
        "8118061334607",
        "8118063956047",
        "8118064578639",
        "8118065627215",
        "8118067331151",
        "8118068838479",
        "8118071918671",
        "8118072344655",
        "8125959929935",
        "8125995515983",
        "8126007345231",
        "8126047256655",
        "8126076420175",
        "8126097752143",
        "8231974666319",
        "8232129364047",
        "8240526983247",
        "8240626565199",
        "8415828082767",
        "8415997853775",
        "8416200294479",
        "8416378617935",
        "8416536494159",
        "8416893403215",
        "8417036271695",
        "8417131167823",
        "8417351237711",
        "8417474740303",
        "8417801011279",
        "8417925595215",
        "8574864097359",
        "8574889328719",
        "8574909841487",
        "8574921801807",
        "8574935924815",
        "8574942609487",
        "8574943526991",
        "8574943952975",
        "8574944608335"
      ]);

      this.waMetroExcludedPostcodes = new Set([
        "0872", "6037", "6041", "6042", "6043", "6044", "6074", "6081", "6082", "6083",
        "6084", "6111", "6124", "6208", "6210", "6211", "6213", "6214", "6215", "6218",
        "6219", "6220", "6221", "6223", "6224", "6225", "6226", "6227", "6228", "6229",
        "6230", "6232", "6233", "6236", "6237", "6239", "6240", "6243", "6244", "6251",
        "6252", "6253", "6254", "6255", "6256", "6258", "6260", "6262", "6271", "6275",
        "6280", "6281", "6282", "6284", "6285", "6286", "6288", "6290", "6302", "6304",
        "6306", "6308", "6309", "6311", "6312", "6313", "6315", "6316", "6317", "6318",
        "6320", "6321", "6322", "6323", "6324", "6326", "6327", "6328", "6330", "6333",
        "6335", "6336", "6337", "6338", "6341", "6343", "6346", "6348", "6350", "6351",
        "6352", "6353", "6355", "6356", "6357", "6358", "6359", "6361", "6363", "6365",
        "6367", "6368", "6369", "6370", "6372", "6373", "6375", "6383", "6384", "6385",
        "6386", "6390", "6391", "6392", "6393", "6394", "6395", "6396", "6397", "6398",
        "6401", "6403", "6405", "6407", "6409", "6410", "6411", "6412", "6413", "6414",
        "6415", "6418", "6419", "6420", "6421", "6422", "6423", "6424", "6425", "6426",
        "6427", "6428", "6429", "6430", "6431", "6432", "6434", "6436", "6437", "6438",
        "6440", "6442", "6443", "6445", "6446", "6447", "6448", "6450", "6452", "6460",
        "6461", "6462", "6463", "6465", "6466", "6467", "6468", "6470", "6472", "6473",
        "6475", "6476", "6477", "6479", "6480", "6484", "6485", "6487", "6488", "6489",
        "6490", "6501", "6502", "6503", "6504", "6505", "6506", "6507", "6509", "6510",
        "6511", "6512", "6513", "6514", "6515", "6516", "6517", "6518", "6519", "6521",
        "6522", "6525", "6528", "6530", "6532", "6535", "6536", "6537", "6556", "6558",
        "6560", "6562", "6564", "6566", "6567", "6568", "6569", "6571", "6572", "6574",
        "6575", "6603", "6605", "6606", "6608", "6609", "6612", "6613", "6614", "6616",
        "6620", "6623", "6625", "6627", "6628", "6630", "6631", "6632", "6635", "6638",
        "6639", "6640", "6642", "6646", "6701", "6705", "6707", "6710", "6711", "6712",
        "6713", "6714", "6716", "6718", "6720", "6721", "6722", "6725", "6726", "6728",
        "6731", "6733", "6740", "6743", "6751", "6753", "6754", "6758", "6760", "6762",
        "6765", "6770", "6798", "6799"
      ]);
    }

    async loadJson(url) {
      if (!url) return null;
      if (this.cache[url]) return this.cache[url];

      const response = await fetch(url, { credentials: "same-origin" });
      if (!response.ok) throw new Error(`Failed to load ${url}`);

      const data = await response.json();
      this.cache[url] = data;
      return data;
    }

    money(value) {
      return Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
    }

    applyMarkup(value, markupPercent) {
      return this.money(Number(value || 0) * (1 + Number(markupPercent || 0) / 100));
    }

    cubicWeightKg(lengthMm, widthMm, heightMm, factorKgPerM3) {
      const l = Number(lengthMm || 0) / 1000;
      const w = Number(widthMm || 0) / 1000;
      const h = Number(heightMm || 0) / 1000;
      return l * w * h * factorKgPerM3;
    }

    chargeableWeightKg(deadWeightKg, cubicWeightKg) {
      return Math.max(Math.max(Number(deadWeightKg || 0), Number(cubicWeightKg || 0)), 1);
    }

    isSaProduct(productId) {
      return this.SA_PRODUCT_IDS.has(String(productId || "").trim());
    }

    getDisplayMultiplier(productId) {
      return this.isSaProduct(productId) ? this.saDisplayMultiplier : this.displayMultiplier;
    }

    normalizePostcode(postcode) {
      return String(postcode || "").trim().padStart(4, "0");
    }

    isEligibleForMetroWAFreeShipping(postcode, cartSubtotalDollars) {
      const normalizedPostcode = this.normalizePostcode(postcode);
      const isWA = normalizedPostcode.startsWith("6");

      if (!isWA) return false;
      if (this.waMetroExcludedPostcodes.has(normalizedPostcode)) return false;

      return Number(cartSubtotalDollars || 0) >= this.freeShippingMinimum;
    }

    getSelectedVariantId(sectionId) {
      const estimatorRoot = document.getElementById(`shipping-estimator-${sectionId}`);
      if (!estimatorRoot) return null;

      const variantInput =
        estimatorRoot.closest(".shopify-section")?.querySelector('form[action*="/cart/add"] [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');

      return variantInput ? String(variantInput.value) : null;
    }

    getProductData(sectionConfig, variantId) {
      const variant = sectionConfig.variants?.[String(variantId)];
      if (!variant) return null;

      return {
        productId: String(sectionConfig.productId || ""),
        weightKg: Number(variant.weightKg || 0),
        lengthMm: Number(variant.lengthMm || 0),
        widthMm: Number(variant.widthMm || 0),
        heightMm: Number(variant.heightMm || 0),
        title: variant.title || "",
        sku: variant.sku || ""
      };
    }

    getManualSurcharge(product) {
      const sku = String(product?.sku || "").trim().toUpperCase();
      return sku === "MB-LRG-TV-1" ? 65 : 0;
    }

    getAlliedZoneRow(postcode, alliedZones) {
      if (!Array.isArray(alliedZones)) return null;
      return alliedZones.find((row) => String(row.postcode).trim() === String(postcode).trim()) || null;
    }

    getTollZoneRow(postcode, tollZones) {
      if (!Array.isArray(tollZones)) return null;
      return tollZones.find((row) => String(row.postcode).trim() === String(postcode).trim()) || null;
    }

    getTransitBusinessDays(postcode, alliedZones) {
      const zoneRow = this.getAlliedZoneRow(postcode, alliedZones);
      if (!zoneRow) return null;

      const perthTransit = Number(zoneRow.roadTransitExPER || 0);
      if (!perthTransit || Number.isNaN(perthTransit)) return null;

      return perthTransit + this.additionalTransitDays;
    }

    addBusinessDays(startDate, businessDaysToAdd) {
      const date = new Date(startDate);
      let added = 0;

      while (added < businessDaysToAdd) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }

      while (date.getDay() === 0 || date.getDay() === 6) {
        date.setDate(date.getDate() + 1);
      }

      return date;
    }

    formatDeliveryDate(date) {
      return new Intl.DateTimeFormat("en-AU", {
        weekday: "long",
        day: "numeric",
        month: "long"
      }).format(date);
    }

    calculateAllied(product, postcode, alliedRates, alliedZones) {
      if (!Array.isArray(alliedRates) || !Array.isArray(alliedZones)) return null;

      const zoneRow = this.getAlliedZoneRow(postcode, alliedZones);
      if (!zoneRow || !zoneRow.gZone) return null;

      const toZone = String(zoneRow.gZone).trim().toUpperCase();
      const rateRow = alliedRates.find((row) =>
        String(row.fromZone).trim().toUpperCase() === "W01" &&
        String(row.toZone).trim().toUpperCase() === toZone
      );
      if (!rateRow) return null;

      const cubicWeight = this.cubicWeightKg(product.lengthMm, product.widthMm, product.heightMm, 250);
      const chargeableWeight = this.chargeableWeightKg(product.weightKg, cubicWeight);

      let cost = Number(rateRow.basic || 0) + chargeableWeight * Number(rateRow.perKg || 0);
      cost = Math.max(Number(rateRow.minCharge || 0), cost);
      cost = this.applyMarkup(cost, 35);

      return { carrier: "Allied", cost: this.money(cost) };
    }

    calculateToll(product, postcode, tollRates, tollZones) {
      if (!Array.isArray(tollZones)) return null;

      const zoneRow = this.getTollZoneRow(postcode, tollZones);
      if (!zoneRow) return null;

      const candidateKeys = [
        zoneRow.destination,
        zoneRow.zoneCode,
        zoneRow.invoiceCode,
        zoneRow.minselZone,
        zoneRow.rateAreaDescription,
        zoneRow.suburb
      ].filter(Boolean).map((v) => String(v).trim().toUpperCase());

      let rateRow = null;

      if (Array.isArray(tollRates)) {
        const perthRates = tollRates.filter(
          (row) => String(row.origin || "").trim().toUpperCase() === "PERTH"
        );

        const matchingRates = perthRates.filter((row) => {
          const rowDestination = String(row.destination || "").trim().toUpperCase();
          return (
            candidateKeys.includes(rowDestination) ||
            candidateKeys.some((key) => rowDestination.includes(key) || key.includes(rowDestination))
          );
        });

        if (matchingRates.length) {
          const cubicWeight = this.cubicWeightKg(product.lengthMm, product.widthMm, product.heightMm, 333);
          const chargeableWeight = this.chargeableWeightKg(product.weightKg, cubicWeight);

          rateRow = matchingRates.find(
            (row) =>
              chargeableWeight >= Number(row.rangeStartKg || 0) &&
              chargeableWeight <= Number(row.rangeEndKg || 0)
          );

          if (!rateRow) {
            rateRow = matchingRates
              .slice()
              .sort((a, b) => Number(a.rangeEndKg || 0) - Number(b.rangeEndKg || 0))
              .find((row) => chargeableWeight <= Number(row.rangeEndKg || 0));
          }

          if (!rateRow) {
            rateRow = matchingRates
              .slice()
              .sort((a, b) => Number(b.rangeEndKg || 0) - Number(a.rangeEndKg || 0))[0];
          }
        }
      }

      if (!rateRow) return null;

      const cubicWeight = this.cubicWeightKg(product.lengthMm, product.widthMm, product.heightMm, 333);
      const chargeableWeight = this.chargeableWeightKg(product.weightKg, cubicWeight);

      let cost = Math.max(
        Number(rateRow.minCharge || 0),
        chargeableWeight * Number(rateRow.ratePerKg || 0)
      );
      cost = this.applyMarkup(cost, 35);

      return { carrier: "Toll", cost: this.money(cost) };
    }

    chooseEstimate(product, postcode, alliedRates, alliedZones, tollRates, tollZones) {
      const allied = this.calculateAllied(product, postcode, alliedRates, alliedZones);
      const toll = this.calculateToll(product, postcode, tollRates, tollZones);

      if (allied && toll) return allied.cost <= toll.cost ? allied : toll;
      return allied || toll || null;
    }

    calculateDisplayRange(baseCost, multiplier = this.displayMultiplier) {
      const adjustedBase = Number(baseCost || 0) * multiplier;
      return {
        low: this.money(adjustedBase * 0.85),
        high: this.money(adjustedBase * 1.15)
      };
    }

    applySellAdjustment(baseCost, meta = {}) {
      let adjusted = Number(baseCost || 0);

      if (
        meta.carrier === "Allied" &&
        meta.fromZone === "W01" &&
        meta.toZone === "V01"
      ) {
        adjusted = adjusted * 1.35;
      }

      return this.money(adjusted);
    }

    getCustomMultiBundleMultiplier(bundleCount) {
      const qty = Number(bundleCount || 0);

      if (qty <= 1) return 1;
      if (qty === 2) return 1.1;
      if (qty === 3) return 1.2;
      if (qty === 4) return 1.3;
      if (qty >= 5) return 1.35;

      return 1;
    }

    getShipmentShippingMode(shipment) {
  const PALLET_TRIGGER_WEIGHT_KG = 50;
  const MAX_PARCEL_LENGTH_MM = 1200;
  const MAX_PARCEL_WIDTH_MM = 1200;
  const MAX_PARCEL_HEIGHT_MM = 1400;

  const totalDeadWeightKg = Number(shipment?.totalDeadWeightKg || 0);

  const maxLengthMm = Number(shipment?.maxBundleLengthMm || 0);
  const maxWidthMm = Number(shipment?.maxBundleWidthMm || 0);
  const maxHeightMm = Number(shipment?.maxBundleHeightMm || 0);

  const oversizedBundle =
    maxLengthMm > MAX_PARCEL_LENGTH_MM ||
    maxWidthMm > MAX_PARCEL_WIDTH_MM ||
    maxHeightMm > MAX_PARCEL_HEIGHT_MM;

  const isPallet =
    totalDeadWeightKg > PALLET_TRIGGER_WEIGHT_KG ||
    oversizedBundle;

  return {
    mode: isPallet ? "Pallet" : "Parcel",
    label: isPallet ? "Ships via pallets" : "Ships via parcels",
    isPallet,
    totalDeadWeightKg,
    oversizedBundle,
    maxLengthMm,
    maxWidthMm,
    maxHeightMm
  };
}

    getTransitHtml(postcode, alliedZones) {
      const transitDays = this.getTransitBusinessDays(postcode, alliedZones);
      if (!transitDays) return "";

      const receiveDate = this.addBusinessDays(new Date(), transitDays);
      return `<p>Receive from <strong>${this.formatDeliveryDate(receiveDate)}</strong></p>`;
    }

    buildFreeShippingHtml(sectionConfig) {
      return `
        <p><strong>${sectionConfig.labels.freeShippingCongratsText || "CONGRATULATIONS YOU HAVE FREE SHIPPING METRO WA FOR YOUR ORDER"}</strong></p>
        <p class="megan-shipping-estimator__result-note">${sectionConfig.labels.checkoutNoteText || ""}</p>
      `;
    }

    renderResult(sectionId, html, mode = "product", postcode = "") {
      const resultId =
        mode === "drawer" ? `DrawerShippingResult-${sectionId}` : `ShippingResult-${sectionId}`;

      const result = document.getElementById(resultId);
      if (!result) return;

      result.hidden = false;
      result.innerHTML = html;

      if (mode === "drawer" && postcode) {
        result.dataset.lastPostcode = postcode;
      }
    }

    async loadRateData(sectionConfig) {

  const palletRatesUrl = sectionConfig.assets.alliedPalletRates || "/cdn/shop/t/2/assets/shipping-allied-pallet-rates.json";

  const [alliedRates, alliedZones, tollRates, tollZones, alliedPalletRates] = await Promise.all([

    this.loadJson(sectionConfig.assets.alliedRates).catch(() => null),

    this.loadJson(sectionConfig.assets.alliedZones).catch(() => null),

    this.loadJson(sectionConfig.assets.tollRates).catch(() => null),

    this.loadJson(sectionConfig.assets.tollZones).catch(() => null),

    this.loadJson(palletRatesUrl).catch(() => null)

  ]);

  return {

    alliedRates,

    alliedZones,

    tollRates,

    tollZones,

    alliedPalletRates

  };

}

    buildEstimateHtml(sectionConfig, range, transitHtml, shippingModeLabel = "") {
  return `
    <p><strong>Shipping from $${range.low.toFixed(2)} - $${range.high.toFixed(2)} + GST</strong></p>
    ${shippingModeLabel ? `<p><strong>${shippingModeLabel}</strong></p>` : ""}
    ${transitHtml}
    <p class="megan-shipping-estimator__result-note">${sectionConfig.labels.checkoutNoteText || ""}</p>
  `;
}

    async calculateProduct(sectionConfig) {
      const sectionId = sectionConfig.sectionId;
      const postcodeInput = document.getElementById(`ShippingPostcode-${sectionId}`);
      if (!postcodeInput) return;

      const postcode = String(postcodeInput.value || "").trim();
      if (!/^\d{4}$/.test(postcode)) {
        this.renderResult(sectionId, `<p>${sectionConfig.labels.invalidPostcodeText}</p>`, "product");
        return;
      }

      this.renderResult(sectionId, `<p>${sectionConfig.labels.loadingText}</p>`, "product");

      const variantId = this.getSelectedVariantId(sectionId);
      const product = this.getProductData(sectionConfig, variantId);

      if (!product) {
        this.renderResult(
          sectionId,
          `<p>${sectionConfig.labels.noEstimateText}</p><p class="megan-shipping-estimator__result-note">${sectionConfig.labels.checkoutNoteText || ""}</p>`,
          "product"
        );
        return;
      }

      try {
        const { alliedRates, alliedZones, tollRates, tollZones } = await this.loadRateData(sectionConfig);
        const estimate = this.chooseEstimate(product, postcode, alliedRates, alliedZones, tollRates, tollZones);

        if (!estimate) {
          this.renderResult(
            sectionId,
            `<p>${sectionConfig.labels.noEstimateText}</p><p class="megan-shipping-estimator__result-note">${sectionConfig.labels.checkoutNoteText || ""}</p>`,
            "product"
          );
          return;
        }

        let toZone = "";
        const alliedZoneRow = this.getAlliedZoneRow(postcode, alliedZones);
        if (alliedZoneRow?.gZone) {
          toZone = String(alliedZoneRow.gZone).trim().toUpperCase();
        }

        let base = Number(estimate.cost || 0) + this.getManualSurcharge(product);
        base = this.applySellAdjustment(base, {
          carrier: estimate.carrier,
          fromZone: "W01",
          toZone
        });

        const range = this.calculateDisplayRange(base, this.getDisplayMultiplier(product.productId));
        const transitHtml = this.getTransitHtml(postcode, alliedZones);

        this.renderResult(
          sectionId,
          this.buildEstimateHtml(sectionConfig, range, transitHtml),
          "product"
        );
      } catch (error) {
        console.error("Shipping estimator error:", error);
        this.renderResult(
          sectionId,
          `<p>${sectionConfig.labels.noEstimateText}</p><p class="megan-shipping-estimator__result-note">${sectionConfig.labels.checkoutNoteText || ""}</p>`,
          "product"
        );
      }
    }

    collectShipmentFromRows(rowSelector) {
      const rows = document.querySelectorAll(rowSelector);
      if (!rows.length) return null;

      let cpbLineCount = 0;
      let singleCPBLineQty = 0;
      let totalDeadWeightKg = 0;
      let totalAlliedCubicWeightKg = 0;
      let totalTollCubicWeightKg = 0;
      let manualSurchargeTotal = 0;
      let firstProductForCarrierContext = null;
      let hasSAProducts = false;
      let hasWAProducts = false;
      let hasCPBProducts = false;
      let hasNonCPBProducts = false;
      let totalCPBBundles = 0;
      let maxBundleLengthMm = 0;
let maxBundleWidthMm = 0;
let maxBundleHeightMm = 0;

      rows.forEach((row) => {
        const qtyInput = row.querySelector("input.qty");
        const quantity = Number(qtyInput?.value || 0);
        if (!quantity) return;

        const productId = String(
          row.dataset.productId ||
          row.dataset.productid ||
          row.getAttribute("data-product-id") ||
          ""
        ).trim();

        const isCPBProduct = String(row.dataset.isCpbProduct || "").trim() === "true";

        const product = {
          productId,
          weightKg: Number(row.dataset.bundleWeightKg || 0),
          lengthMm: Number(row.dataset.bundleLengthMm || 0),
          widthMm: Number(row.dataset.bundleWidthMm || 0),
          heightMm: Number(row.dataset.bundleHeightMm || 0),
          sku: row.dataset.sku || "",
          title: row.dataset.title || ""
        };

        maxBundleLengthMm = Math.max(maxBundleLengthMm, product.lengthMm);

maxBundleWidthMm = Math.max(maxBundleWidthMm, product.widthMm);

maxBundleHeightMm = Math.max(maxBundleHeightMm, product.heightMm);

        if (!firstProductForCarrierContext) {
          firstProductForCarrierContext = product;
        }

        if (this.isSaProduct(productId)) {
          hasSAProducts = true;
        } else {
          hasWAProducts = true;
        }

        if (isCPBProduct) {
          hasCPBProducts = true;
          totalCPBBundles += quantity;
          cpbLineCount += 1;
          singleCPBLineQty = quantity;
        } else {
          hasNonCPBProducts = true;
        }

        totalDeadWeightKg += product.weightKg * quantity;
        totalAlliedCubicWeightKg += this.cubicWeightKg(
          product.lengthMm,
          product.widthMm,
          product.heightMm,
          250
        ) * quantity;
        totalTollCubicWeightKg += this.cubicWeightKg(
          product.lengthMm,
          product.widthMm,
          product.heightMm,
          333
        ) * quantity;

        manualSurchargeTotal += this.getManualSurcharge(product) * quantity;
      });

      if (!firstProductForCarrierContext) return null;

      return {
  firstProductForCarrierContext,
  totalDeadWeightKg,
  totalAlliedCubicWeightKg,
  totalTollCubicWeightKg,
  manualSurchargeTotal,
  hasSAProducts,
  hasWAProducts,
  hasCPBProducts,
  hasNonCPBProducts,
  totalCPBBundles,
  cpbLineCount,
  singleCPBLineQty,
  maxBundleLengthMm,
  maxBundleWidthMm,
  maxBundleHeightMm
};
    }

    calculateCombinedAllied(postcode, rates, shipment) {
      const zoneRow = this.getAlliedZoneRow(postcode, rates.alliedZones);
      if (!zoneRow || !zoneRow.gZone || !Array.isArray(rates.alliedRates)) return null;

      const toZone = String(zoneRow.gZone).trim().toUpperCase();
      const rateRow = rates.alliedRates.find((row) =>
        String(row.fromZone).trim().toUpperCase() === "W01" &&
        String(row.toZone).trim().toUpperCase() === toZone
      );

      if (!rateRow) return null;

      const chargeableWeight = Math.max(
        shipment.totalDeadWeightKg,
        shipment.totalAlliedCubicWeightKg,
        1
      );

      let cost = Number(rateRow.basic || 0) + chargeableWeight * Number(rateRow.perKg || 0);
      cost = Math.max(Number(rateRow.minCharge || 0), cost);
      cost = this.applyMarkup(cost, 35);

      return { carrier: "Allied", cost: this.money(cost) };
      
    }

    calculateCombinedAlliedPallet(postcode, rates, shipment) {
  const PALLET_LENGTH_MM = 1200;
  const PALLET_WIDTH_MM = 1200;
  const PALLET_HEIGHT_MM = 1400;
  const PALLET_TRIGGER_WEIGHT_KG = 50;

  const zoneRow = this.getAlliedZoneRow(postcode, rates.alliedZones);

  if (!zoneRow || !zoneRow.gZone || !Array.isArray(rates.alliedPalletRates)) {
    return null;
  }

  const toZone = String(zoneRow.gZone).trim().toUpperCase();

  const rateRow = rates.alliedPalletRates.find((row) =>
    String(row.fromZone || row.originZone || "").trim().toUpperCase() === "W01" &&
    String(row.toZone || row.destinationZone || row.zone || "").trim().toUpperCase() === toZone
  );

  if (!rateRow) return null;

  const totalDeadWeightKg = Number(shipment.totalDeadWeightKg || 0);
  const totalCubicMetres = Number(shipment.totalAlliedCubicWeightKg || 0) / 250;

  const palletCubicMetres =
    (PALLET_LENGTH_MM / 1000) *
    (PALLET_WIDTH_MM / 1000) *
    (PALLET_HEIGHT_MM / 1000);

  const palletsByVolume = Math.ceil(totalCubicMetres / palletCubicMetres);
  const palletsByWeight = totalDeadWeightKg > PALLET_TRIGGER_WEIGHT_KG ? 1 : 0;

  const palletCount = Math.max(palletsByVolume, palletsByWeight);

  if (!palletCount || palletCount < 1) {
    return null;
  }

  const palletRate =
    Number(rateRow.perPallet || 0) ||
    Number(rateRow.rate || 0) ||
    Number(rateRow.palletRate || 0) ||
    Number(rateRow.price || 0) ||
    Number(rateRow.cost || 0);

  if (!palletRate || !isFinite(palletRate)) {
    return null;
  }

  let cost = palletRate * palletCount;

  cost = this.applyMarkup(cost, 35);

  return {
    carrier: "Allied Pallet",
    cost: this.money(cost),
    palletCount: palletCount
  };
}

    calculateCombinedToll(postcode, rates, shipment) {
      const zoneRow = this.getTollZoneRow(postcode, rates.tollZones);
      if (!zoneRow || !Array.isArray(rates.tollRates)) return null;

      const candidateKeys = [
        zoneRow.destination,
        zoneRow.zoneCode,
        zoneRow.invoiceCode,
        zoneRow.minselZone,
        zoneRow.rateAreaDescription,
        zoneRow.suburb
      ].filter(Boolean).map((v) => String(v).trim().toUpperCase());

      const perthRates = rates.tollRates.filter(
        (row) => String(row.origin || "").trim().toUpperCase() === "PERTH"
      );

      const matchingRates = perthRates.filter((row) => {
        const rowDestination = String(row.destination || "").trim().toUpperCase();
        return (
          candidateKeys.includes(rowDestination) ||
          candidateKeys.some((key) => rowDestination.includes(key) || key.includes(rowDestination))
        );
      });

      if (!matchingRates.length) return null;

      const chargeableWeight = Math.max(
        shipment.totalDeadWeightKg,
        shipment.totalTollCubicWeightKg,
        1
      );

      let rateRow = matchingRates.find(
        (row) =>
          chargeableWeight >= Number(row.rangeStartKg || 0) &&
          chargeableWeight <= Number(row.rangeEndKg || 0)
      );

      if (!rateRow) {
        rateRow = matchingRates
          .slice()
          .sort((a, b) => Number(a.rangeEndKg || 0) - Number(b.rangeEndKg || 0))
          .find((row) => chargeableWeight <= Number(row.rangeEndKg || 0));
      }

      if (!rateRow) {
        rateRow = matchingRates
          .slice()
          .sort((a, b) => Number(b.rangeEndKg || 0) - Number(a.rangeEndKg || 0))[0];
      }

      if (!rateRow) return null;

      let cost = Math.max(
        Number(rateRow.minCharge || 0),
        chargeableWeight * Number(rateRow.ratePerKg || 0)
      );
      cost = this.applyMarkup(cost, 35);

      return { carrier: "Toll", cost: this.money(cost) };
    }

    async calculateCartLike(sectionConfig, postcode, rowSelector, mode) {

      this.renderResult(

        sectionConfig.sectionId,

        `<p>${sectionConfig.labels.loadingText}</p>`,

        mode,

        postcode

      );

      const rates = await this.loadRateData(sectionConfig);
      const shipment = this.collectShipmentFromRows(rowSelector);

      if (!shipment) {
        this.renderResult(
          sectionConfig.sectionId,
          `<p>${sectionConfig.labels.noEstimateText}</p><p class="megan-shipping-estimator__result-note">${sectionConfig.labels.checkoutNoteText || ""}</p>`,
          mode,
          postcode
        );
        return;
      }

      const shippingMode = this.getShipmentShippingMode(shipment);

const alliedAdjusted = shippingMode.isPallet
  ? null
  : this.calculateCombinedAllied(postcode, rates, shipment);

const tollAdjusted = shippingMode.isPallet
  ? null
  : this.calculateCombinedToll(postcode, rates, shipment);

const alliedPalletAdjusted = shippingMode.isPallet
  ? this.calculateCombinedAlliedPallet(postcode, rates, shipment)
  : null;

const availableEstimates = shippingMode.isPallet
  ? [alliedPalletAdjusted].filter(Boolean)
  : [alliedAdjusted, tollAdjusted].filter(Boolean);

const estimate = availableEstimates.length
  ? availableEstimates.sort(function(a, b) {
      return Number(a.cost || 0) - Number(b.cost || 0);
    })[0]
  : null;

console.log("Cart shipping mode:", {
  shippingMode,
  shipment,
  alliedAdjusted,
  tollAdjusted,
  alliedPalletAdjusted,
  selectedEstimate: estimate
});

      if (!estimate) {
        this.renderResult(
          sectionConfig.sectionId,
          `<p>${sectionConfig.labels.noEstimateText}</p><p class="megan-shipping-estimator__result-note">${sectionConfig.labels.checkoutNoteText || ""}</p>`,
          mode,
          postcode
        );
        return;
      }

      let toZone = "";
      const alliedZoneRow = this.getAlliedZoneRow(postcode, rates.alliedZones);
      if (alliedZoneRow?.gZone) {
        toZone = String(alliedZoneRow.gZone).trim().toUpperCase();
      }

      let base = Number(estimate.cost || 0) + shipment.manualSurchargeTotal;

      base = this.applySellAdjustment(base, {
        carrier: estimate.carrier,
        fromZone: "W01",
        toZone
      });

      const cartResponse = await fetch("/cart.js", { credentials: "same-origin" }).then((r) => r.json());
      const cartSubtotalDollars = Number(cartResponse?.total_price || 0) / 100;

      if (this.isEligibleForMetroWAFreeShipping(postcode, cartSubtotalDollars)) {
        this.renderResult(
          sectionConfig.sectionId,
          this.buildFreeShippingHtml(sectionConfig),
          mode,
          postcode
        );
        return;
      }

      let multiplier = this.displayMultiplier;

if (estimate.carrier === "Allied Pallet") {
  multiplier = 1;
} else if (shipment.hasSAProducts && !shipment.hasWAProducts) {
  multiplier = this.saDisplayMultiplier;
}

const range = this.calculateDisplayRange(base, multiplier);
const transitHtml = this.getTransitHtml(postcode, rates.alliedZones);

this.renderResult(
  sectionConfig.sectionId,
  this.buildEstimateHtml(sectionConfig, range, transitHtml, shippingMode.label),
  mode,
  postcode
);
    }

    async calculateCart(sectionConfig) {
      const sectionId = sectionConfig.sectionId;
      const postcodeInput = document.getElementById(`CartShippingPostcode-${sectionId}`);
      if (!postcodeInput) return;

      const postcode = String(postcodeInput.value || "").trim();
      if (!/^\d{4}$/.test(postcode)) {
        this.renderResult(sectionId, `<p>${sectionConfig.labels.invalidPostcodeText}</p>`, "cart");
        return;
      }

      await this.calculateCartLike(sectionConfig, postcode, '#Cart tr[id^="CartItem-"]', "cart");
    }

    async calculateDrawer(sectionConfig) {
      const sectionId = sectionConfig.sectionId;
      const postcodeInput = document.getElementById(`DrawerShippingPostcode-${sectionId}`);
      if (!postcodeInput) return;

      const postcode = String(postcodeInput.value || "").trim();
      if (!/^\d{4}$/.test(postcode)) {
        this.renderResult(
          sectionId,
          `<p>${sectionConfig.labels.invalidPostcodeText}</p>`,
          "drawer",
          postcode
        );
        return;
      }

      sessionStorage.setItem(this.drawerStorageKey, postcode);
      await this.calculateCartLike(
        sectionConfig,
        postcode,
        '#Cart-Drawer .product-cart-item[id^="CartDrawerItem-"]',
        "drawer"
      );
    }
  }

  function registerShippingConfigs() {
    window.Boxes24ShippingEstimator = window.Boxes24ShippingEstimator || { sections: {} };

    document.querySelectorAll(".boxes24-shipping-config").forEach((node) => {
      try {
        const config = JSON.parse(node.textContent);
        if (config && config.sectionId) {
          window.Boxes24ShippingEstimator.sections[String(config.sectionId)] = config;
        }
      } catch (error) {
        console.error("Failed to parse shipping estimator config:", error);
      }
    });
  }

  function getSectionConfig(sectionId) {
    registerShippingConfigs();

    const key = String(sectionId || "").trim();
    if (window.Boxes24ShippingEstimator?.sections?.[key]) {
      return window.Boxes24ShippingEstimator.sections[key];
    }

    if (key === "drawer" && window.Boxes24ShippingEstimator?.sections?.drawer) {
      return window.Boxes24ShippingEstimator.sections.drawer;
    }

    return null;
  }

  function restoreDrawerPostcodeAndRecalculate() {
    const input = document.querySelector("[data-boxes24-drawer-shipping-postcode]");
    if (!input) return;

    const postcode = sessionStorage.getItem("boxes24DrawerShippingPostcode") || "";
    if (!postcode) return;

    const currentValue = (input.value || "").trim();
    if (currentValue !== postcode) {
      input.value = postcode;
    }

    if (!/^\d{4}$/.test(postcode)) return;

    const result = document.querySelector('[id^="DrawerShippingResult-"]');
    const alreadyCalculatedForPostcode =
      result && result.dataset && result.dataset.lastPostcode === postcode;

    if (alreadyCalculatedForPostcode) return;

    const sectionId = input.dataset.sectionId;
    if (sectionId && typeof window.Boxes24CalculateDrawerShipping === "function") {
      window.Boxes24CalculateDrawerShipping(sectionId);
    }
  }

  window.Boxes24CalculateProductShipping = async function (sectionId) {
    const sectionConfig = getSectionConfig(sectionId);
    if (!sectionConfig) return;
    const estimator = new ShippingEstimator();
    await estimator.calculateProduct(sectionConfig);
  };

  window.Boxes24CalculateCartShipping = async function (sectionId) {
    const sectionConfig = getSectionConfig(sectionId);
    if (!sectionConfig) return;
    const estimator = new ShippingEstimator();
    await estimator.calculateCart(sectionConfig);
  };

  window.Boxes24CalculateDrawerShipping = async function (sectionId) {
    const sectionConfig = getSectionConfig(sectionId);
    if (!sectionConfig) return;
    const estimator = new ShippingEstimator();
    await estimator.calculateDrawer(sectionConfig);
  };

  window.initBoxes24ShippingEstimator = function () {
    registerShippingConfigs();

    if (document.body.dataset.boxes24ShippingEstimatorBound === "true") return;
    document.body.dataset.boxes24ShippingEstimatorBound = "true";

    document.addEventListener("click", function (event) {
      const productButton = event.target.closest("[data-boxes24-product-shipping-calculate]");
      if (productButton) {
        event.preventDefault();
        const sectionId = productButton.dataset.sectionId;
        if (sectionId && typeof window.Boxes24CalculateProductShipping === "function") {
          window.Boxes24CalculateProductShipping(sectionId);
        }
        return;
      }

      const cartButton = event.target.closest("[data-boxes24-cart-shipping-calculate]");
      if (cartButton) {
        event.preventDefault();
        const sectionId = cartButton.dataset.sectionId;
        if (sectionId && typeof window.Boxes24CalculateCartShipping === "function") {
          window.Boxes24CalculateCartShipping(sectionId);
        }
        return;
      }

      const drawerButton = event.target.closest("[data-boxes24-drawer-shipping-calculate]");
      if (drawerButton) {
        event.preventDefault();
        const sectionId = drawerButton.dataset.sectionId;
        if (sectionId && typeof window.Boxes24CalculateDrawerShipping === "function") {
          window.Boxes24CalculateDrawerShipping(sectionId);
        }
      }
    });

    document.addEventListener("keydown", function (event) {
      const productInput = event.target.closest("[data-boxes24-product-shipping-postcode]");
      if (productInput && event.key === "Enter") {
        event.preventDefault();
        const sectionId = productInput.dataset.sectionId;
        if (sectionId && typeof window.Boxes24CalculateProductShipping === "function") {
          window.Boxes24CalculateProductShipping(sectionId);
        }
        return;
      }

      const cartInput = event.target.closest("[data-boxes24-cart-shipping-postcode]");
      if (cartInput && event.key === "Enter") {
        event.preventDefault();
        const sectionId = cartInput.dataset.sectionId;
        if (sectionId && typeof window.Boxes24CalculateCartShipping === "function") {
          window.Boxes24CalculateCartShipping(sectionId);
        }
        return;
      }

      const drawerInput = event.target.closest("[data-boxes24-drawer-shipping-postcode]");
      if (drawerInput && event.key === "Enter") {
        event.preventDefault();
        const sectionId = drawerInput.dataset.sectionId;
        if (sectionId && typeof window.Boxes24CalculateDrawerShipping === "function") {
          window.Boxes24CalculateDrawerShipping(sectionId);
        }
      }
    });

    document.addEventListener("input", function (event) {
      const drawerInput = event.target.closest("[data-boxes24-drawer-shipping-postcode]");
      if (!drawerInput) return;

      sessionStorage.setItem("boxes24DrawerShippingPostcode", drawerInput.value.trim());
    });

    const drawerRoot = document.getElementById("Cart-Drawer");
    if (drawerRoot && !drawerRoot.dataset.boxes24ShippingObserved) {
      drawerRoot.dataset.boxes24ShippingObserved = "true";

      let lastDrawerItemCount = document.querySelectorAll(
        '#Cart-Drawer .product-cart-item[id^="CartDrawerItem-"]'
      ).length;
      let restoreTimeout = null;

      const observer = new MutationObserver(() => {
        const currentDrawerItemCount = document.querySelectorAll(
          '#Cart-Drawer .product-cart-item[id^="CartDrawerItem-"]'
        ).length;

        if (currentDrawerItemCount !== lastDrawerItemCount) {
          lastDrawerItemCount = currentDrawerItemCount;

          clearTimeout(restoreTimeout);
          restoreTimeout = setTimeout(() => {
            restoreDrawerPostcodeAndRecalculate();
          }, 150);
        }
      });

      observer.observe(drawerRoot, { childList: true, subtree: true });
    }

    restoreDrawerPostcodeAndRecalculate();
  };

  document.addEventListener("DOMContentLoaded", function () {
    if (typeof window.initBoxes24ShippingEstimator === "function") {
      window.initBoxes24ShippingEstimator();
    }
  });
})();